import { SUPPRESSION_LISTS, SUPPRESSION_LIST } from '@mm/api-routes';
import { SuppressionList } from '../model/SuppressionListModel';
import AuthenticatedController from './AuthenticatedController';

export default class SuppressionListsController extends AuthenticatedController {
  static async getById(facebookPageId: number, id: number) {
    return super.get(SUPPRESSION_LIST(facebookPageId, id));
  }

  static async getAll(facebookPageId: number) {
    return super.get(SUPPRESSION_LISTS(facebookPageId));
  }

  static async create(
    facebookPageId: number,
    suppressionList: Partial<SuppressionList>,
  ): Promise<SuppressionList> {
    return super.post(SUPPRESSION_LISTS(facebookPageId), suppressionList);
  }

  static async update(
    facebookPageId: number,
    suppressionList: Partial<SuppressionList> & { id: number },
  ): Promise<SuppressionList> {
    return super.put(
      SUPPRESSION_LIST(facebookPageId, suppressionList.id),
      suppressionList,
    );
  }

  static async deleteList(facebookPageId: number, suppressionListId: number) {
    return super.delete(SUPPRESSION_LIST(facebookPageId, suppressionListId));
  }
}
